module.exports = __webpack_public_path__ + "img/text_desktop_eng.1af50e5.svg";